import { SelectionTitleLists } from '@/data/enums'

export const imageTitles = {
  [SelectionTitleLists.Activity]: [
    'activity_gaming',
    'activity_goingout',
    'activity_cooking',
    'activity_shopping',
    'activity_festival',
    'activity_music',
    'activity_terrace',
    'activity_cycling',
    'activity_movie',
    'activity_culture',
    'activity_adventure',
    'activity_study'
  ],
  [SelectionTitleLists.ActivityOverThirtySix]: [
    'activity_fishing',
    'activity_gardening',
    'activity_cooking',
    'activity_shopping',
    'activity_hiking',
    'activity_mindgames',
    'activity_terrace',
    'activity_cycling',
    'activity_tv',
    'activity_citytrip',
    'activity_hobby',
    'activity_reading'
  ],
  [SelectionTitleLists.Gender]: [
    'gender_male',
    'gender_female'
  ],
  [SelectionTitleLists.Glasses]: [
    'glass_daily',
    'glass_screen',
    'glass_read',
    'glass_sun',
    'glass_sport',
    'glass_lens'
  ],
  [SelectionTitleLists.Screen]: [
    'screen_smartphone',
    'screen_tablet',
    'screen_desktop',
    'screen_laptop',
    'screen_magazine',
    'screen_book'
  ],
  [SelectionTitleLists.Sport]: [
    'sport_watersport',
    'sport_running',
    'sport_cycling',
    'sport_wintersports',
    'sport_fitness',
    'sport_hiking',
    'sport_golf',
    'sport_tennis',
    'sport_ballsports'
  ],
  [SelectionTitleLists.Transport]: [
    'transport_transport',
    'transport_business',
    'transport_private',
    'transport_motorcycle',
    'transport_bicycle',
    'transport_publictransport'
  ]
}
